export const checkImagesMap = {
  "Tomar foto 1": "foto1",
  "Tomar foto 2": "foto2",
  "Tomar foto 3": "foto3",
  "Tomar foto 4": "foto4"
};
